import { SentryWrapper as Sentry } from '../sentry'

const trackerSend = (eventName, eventPayload, options) => {
  Sentry.addBreadcrumb('tracker', eventName, eventPayload, options)

  /* eslint-disable */
  try {
    if (window.Tracker) {
      window.Tracker.track(eventName, eventPayload, options)
    } else {
      console.log('TRACKER EVENT: ', eventName, eventPayload, options)
    }
  } catch (error) {
    console.error(`Error on send Tracker event: ${error}`)
  }
  /* eslint-enable */
}

export default trackerSend
